import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaGithub, FaTwitter, FaLinkedin, FaMedium, FaEnvelope } from 'react-icons/fa';

function About() {
  const bloggerInfo = {
    name: 'Omkar Narayan Bhal',
    role: 'Content Creator & Tech Enthusiast',
    image: '/assets/images/author.jpeg', 
    bio: 'Passionate about sharing knowledge through technical tutorials, personal growth stories, and exploring the intersection of technology and creativity.',
    social: {
      twitter: 'https://twitter.com/alexsmith',
      linkedin: 'https://linkedin.com/in/alexsmith',
      github: 'https://github.com/alexsmith',
      medium: 'https://medium.com/@alexsmith',
      email: 'mailto:alex@example.com'
    },
    interests: [
      'Web Development',
      'Productivity Systems',
      'coding',
      'Photography',
      'AI Ethics',
      'Writing'
    ]
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="container mx-auto px-4 py-8 max-w-4xl"
    >
      <h1 className="text-3xl font-bold mb-8 bg-gradient-to-r from-primary-500 to-secondary-500 bg-clip-text text-transparent">
        About Me
      </h1>

      <div className="prose dark:prose-invert max-w-none">
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">My Journey</h2>
          <p className="text-gray-600 dark:text-gray-300">
            As a full-stack developer turned writer, I've spent a lot of time to exploring the digital landscape. 
            This blog is my canvas where I share my writen stories, technical tutorials, personal growth experiences, and lessons 
            learned from building products and cultivating meaningful digital relationships.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">What I Write About</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-soft">
              <h3 className="text-xl font-semibold mb-2">Tech Deep Dives & my stupid writen stories</h3>
              <p className="text-gray-600 dark:text-gray-300">
                Practical guides on web development, tools, and emerging technologies and lot more.
              </p>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-soft">
              <h3 className="text-xl font-semibold mb-2">Creator Lifestyle</h3>
              <p className="text-gray-600 dark:text-gray-300">
                Balancing technical work with creative expression and digital nomadism
              </p>
            </div>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Personal Profile</h2>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-soft">
            <img
              src={bloggerInfo.image}
              alt={bloggerInfo.name}
              className="w-48 h-48 rounded-full mx-auto mb-6 object-cover border-4 border-primary-100 dark:border-gray-700"
            />
            <h3 className="text-2xl font-bold text-center mb-2">{bloggerInfo.name}</h3>
            <p className="text-primary-500 text-center mb-4">{bloggerInfo.role}</p>
            <p className="text-gray-600 dark:text-gray-300 text-center mb-6">{bloggerInfo.bio}</p>
            
            <div className="mb-6">
              <h4 className="text-lg font-semibold mb-3 text-center">Current Interests</h4>
              <div className="flex flex-wrap justify-center gap-2">
                {bloggerInfo.interests.map((interest) => (
                  <span 
                    key={interest}
                    className="px-3 py-1 bg-primary-100 dark:bg-gray-700 rounded-full text-sm"
                  >
                    {interest}
                  </span>
                ))}
              </div>
            </div>

            {/* <div className="flex justify-center space-x-5 mt-6">
              {Object.entries(bloggerInfo.social).map(([platform, url]) => (
                <a
                  key={platform}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                  aria-label={`${platform} profile`}
                >
                  {platform === 'twitter' && <FaTwitter size={24} />}
                  {platform === 'linkedin' && <FaLinkedin size={24} />}
                  {platform === 'github' && <FaGithub size={24} />}
                  {platform === 'medium' && <FaMedium size={24} />}
                  {platform === 'email' && <FaEnvelope size={24} />}
                </a>
              ))}
            </div> */}
          </div>
        </section>

        <section className="text-center">
          <h2 className="text-2xl font-semibold mb-4">Let's Connect</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            Want to collaborate or suggest a topic? I'd love to hear from you!
          </p>
          <Link
            to="/auth"
            className="inline-block bg-primary-500 text-white px-6 py-3 rounded-lg hover:bg-primary-600 transition-colors"
          >
            Send Message
          </Link>
        </section>
      </div>
    </motion.div>
  );
}

export default About;
